import $ from 'jquery';
import React,{useEffect,useState} from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useSearchParams,Link,useParams } from 'react-router-dom';

import {btnSetColor_CBack,CallMapMethod,RespBkMthdMapp,AjaxCallMethod,
    GetImgCertUser,sortListNew,TableDatePicker,CallMapMethod_CBack} from '../function_lib/common_lib';
import {getRoleDetails,CallCMSMapMethod_CBack,pgIndexLimit,writeJSLib} from '../function_lib/common_cms';

import Front_Header from './front_header';
// import Footer from './footer';
import Comp_Sf_Footer from './comp_sf_footer';


import Article_Listing_n from '../sample_comp_v2/article_listing';
import {Home_Banner_n,Home_Banner2Div_n,Home_Banner_WithNews_n} from '../sample_comp_v2/home_banner';
import Article_Blogs_n from '../sample_comp_v2/article_blogs';
import Left_Img_Txt_Desc_n from '../sample_comp_v2/left_img_txt_desc';
import Single_Img_Msg_n from '../sample_comp_v2/single_img_msg';
import Txt_Description_n from '../sample_comp_v2/txt_description';
import ImageGallery_n from '../sample_comp_v2/image_gallery';
import Video_Slider_n from '../sample_comp_v2/video_slider';
import {Testimonials_n} from '../sample_comp_v2/testimonials';
import Image_Collarge_Grid_n from '../sample_comp_v2/image_collarge_grid';
import Text_Thumbnail_n from '../sample_comp_v2/text_thumbnail';
import Comp_Group_Page from '../sample_comp_v2/comp_group_page';
import {Collapse_Pan_n,Collapse_Pan_Images_n} from '../sample_comp_v2/collapse_pan';
import Card_List from '../sample_comp_v2/card_list';
import Comp_Ashtech_Main_Banner from '../sample_comp_v2/comp_ashtech_main_banner';

import Blog_Listing_New from '../sample_comp_v2/blog_listing_new';

import Product_Slider from '../sample_comp_v2/product_slider';

import './contact_us.css';

export const Member_Reg=()=>{
    const location = useLocation();
   
    const [metaHeaders,setMetaHeaders]=useState({
        top_title:"Dashora and Company",
        top_description:"Dashora and Company",
        top_keywords:"Dashora and Company"
    })
     const [loc,setLoc]=useState('');
    const [stPgData,setStPgData]=useState([]);
    const [_pgIndexed,setPgIndexed]=useState([]);

    const [useJSList,setJsList]=useState(0);


    // member page stacks
    const [stGotraList,setGotraList]=useState([]);
    const [stStates,setStates]=useState([]);

    const getStates=()=>{
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getStates"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getStates";
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            if(data!=="0"){
                let jsList=JSON.parse(data);
                setStates(jsList);
            }
        })
    }

    const getGotraList=()=>{
        
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getGotraList"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getGotraList";
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            if(data!=="0"){
                let jsList=JSON.parse(data);
                setGotraList(jsList);
            }
        })
    }

    //contact request --
   const addMemeberReq=()=>{
    // alert("Thanks for your Registration, Out team will contact soon, for the verification process.");
    // window.location.reload();
    if($("#password").val()!==$("#re_password").val()){
        alert("The password and the confirmation password do not match");
        return;
    }
        btnSetColor_CBack(this,"member-form","register_member",function(data,msg){
          // alert(msg);
            if(data==="-10" || data===-10){
                alert(msg);
            }else if(data!=="0"){
                alert("Thanks for your Registration, Our team will contact soon for the verification process...");
                window.location.reload();
            }else if(data==="0"){
                alert(msg);
            }
        })
    }

    // CMS data calling
    const getCMSData=(_loc)=>{
        
        //alert(_loc);
        var pgMap=[];
        pgMap.push({name:"curl_type",value:"getPgData"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"loc",value:_loc});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getPgData";
        CallCMSMapMethod_CBack(this,pgMap,function(data,msg){
            //alert(data);
            let listObj=JSON.parse(data);
            setStPgData(listObj.access);
            if(listObj.length>0){
                setMetaHeaders({top_title:listObj})
            }

            if(useJSList===0)
                {
                writeJSLib();
                setJsList(1);
            }

            AjaxCallMethod(this,"okSuccCNOT");
        });
        
    }
   

    useEffect(()=>{
        setPgIndexed(pgIndexLimit());
        getGotraList();
        getStates();
        //alert(location["pathname"].substr(1));
        //setLocation(useLocation());
        //setLoc();
        let _loc=location["pathname"].substr(1);
        if(_loc===""){
            _loc="home";
        }
        setLoc(_loc);
        //alert(loc);
        getCMSData(_loc);
        
    },[])
    useEffect(()=>{
        document.getElementById("togglePassword").addEventListener("click", function () {
            const input = document.getElementById("password");
            const type = input.type === "password" ? "text" : "password";
            input.type = type;
        
            // Toggle icon between eye and eye-slash
            this.classList.toggle("fa-eye-slash");
        });

        document.getElementById("toggleRePassword").addEventListener("click", function () {
            const input = document.getElementById("re_password");
            const type = input.type === "password" ? "text" : "password";
            input.type = type;
        
            // Toggle icon between eye and eye-slash
            this.classList.toggle("fa-eye-slash");
        });
        
    },[useJSList])

return(<>
 
    {/* <!-- Navbar & Carousel End --> */}

<Front_Header loc={loc}/>
    {/* add cms componet */}
    {_pgIndexed.map((item_m,mi)=>{
       // alert(mi+"=== "+_pgIndexed.length);
        if(mi===_pgIndexed.length-1){
         //  alert("i m in set state");
          // setJsList(1);
       }
                if(mi===6){
                    if(typeof stPgData[mi]!=="undefined"){
                        //alert(JSON.stringify(this.state.stPgData[mi]));
                    }
                    
                }
return(<>{typeof stPgData[mi]!=="undefined"?<>
    {/*not in use <Home_Banner_n/> */}
    
    {typeof stPgData[mi]["home_banner"]!=="undefined"?<Home_Banner_WithNews_n lsData={stPgData[mi]["home_banner"]} />:''}
    {typeof stPgData[mi]["home_banner2div"]!=="undefined"?<Home_Banner2Div_n lsData={stPgData[mi]["home_banner2div"]} />:''}
    {typeof stPgData[mi]["list_slider"]!=="undefined"?<Article_Blogs_n lsData={stPgData[mi]["list_slider"]} />:''}

    {typeof stPgData[mi]["card_list"]!=="undefined"?<Card_List lsData={stPgData[mi]["card_list"]} />:''}
    
    {typeof stPgData[mi]["img_text_desc_img_left"]!=="undefined"?<Left_Img_Txt_Desc_n lsData={stPgData[mi]["img_text_desc_img_left"]} />:''}
    {typeof stPgData[mi]["img_text_desc_img_right"]!=="undefined"?<Left_Img_Txt_Desc_n lsData={stPgData[mi]["img_text_desc_img_right"]} img_right="true" />:''}
    
    {typeof stPgData[mi]["image_collarge_grid"]!=="undefined"?<Image_Collarge_Grid_n lsData={stPgData[mi]["image_collarge_grid"]} />:''}
    {typeof stPgData[mi]["video_slider"]!=="undefined"?<Video_Slider_n lsData={stPgData[mi]["video_slider"]} />:''}

    {typeof stPgData[mi]["text_thumbnail"]!=="undefined"?<Text_Thumbnail_n lsData={stPgData[mi]["text_thumbnail"]} />:''}

    {typeof stPgData[mi]["text_description"]!=="undefined"?<Txt_Description_n lsData={stPgData[mi]["text_description"]} />:''}

    {typeof stPgData[mi]["article_listing"]!=="undefined"?<Article_Listing_n isSort={loc==="e_news"?true:false} sortparam={["entry_date",false,"date"]} lsData={stPgData[mi]["article_listing"]} />:''}

    {typeof stPgData[mi]["blog_listing"]!=="undefined"?<Blog_Listing_New isSort={loc==="e_news"?true:false} sortparam={["entry_date",false,"date"]} lsData={stPgData[mi]["blog_listing"]} />:''}

    {typeof stPgData[mi]["single_img_text"]!=="undefined"?<Single_Img_Msg_n lsData={stPgData[mi]["single_img_text"]} />:''}

    {typeof stPgData[mi]["image_gallery"]!=="undefined"?<ImageGallery_n lsData={stPgData[mi]["image_gallery"]} />:''}

    {typeof stPgData[mi]["collapse_pan"]!=="undefined"?<Collapse_Pan_Images_n lsData={stPgData[mi]["collapse_pan"]}/>:''}
    
    {typeof stPgData[mi]["testimonials"]!=="undefined"?<Testimonials_n lsData={stPgData[mi]["testimonials"]}/>:''}
    
    
    </>:''}</>);
   
        })
        }
        {/* end of cms part */}

        <div className="container-sm container-fluid px-1 py-5 mx-auto">
        <div className="row d-flex justify-content-center">
        <div className="col-xl-12 col-lg-12 col-md-10 text-center">
                {/* <div className="col-lg-4 col-md-5 mb-lm-60px col-sm-12 col-xs-12 w-sm-100">
                    <div className="contact-info-wrap">
                        <h2 className="title" >Contact Us</h2>
                        <div className="single-contact-info" >
                            <div className="contact-info-inner">
                                <span className="sub-title">OFFICE</span>
                            </div>
                            <div className="contact-info-dec">
                                <p>SA-2, 1st Floor,<br></br>Dawa Bazaar Freeganj,<br></br>Ujjain MP - 456010</p>
                            </div>
                        </div>
                        <div className="single-contact-info" >
                            <div className="contact-info-inner">
                                <span className="sub-title">CONTACTS</span>
                            </div>
                            <div className="contact-info-dec">
                                <p><a href="tel:911808890114">+91 1800-889-0114</a></p>
                            </div>
                        </div>
                        <div className="single-contact-info" >
                            <div className="contact-info-inner">
                                <span className="sub-title">EMAIL</span>
                            </div>
                            <div className="contact-info-dec">
                            <p><a href="mailto://info@mbdhwellness.com">info@mbdhwellness.com</a></p>
                            </div>
                        </div>
                       
                    </div>
                </div> */}
                <div className="card dia_cart border-box-3">
                <div class="container khandelwal_registration_form text-start">
    <h2 class="text-center mb-4">Registration Form</h2>
    <form className="contact-form-style form-control11 " name="member-form" id="member-form">
    <input type="hidden" name="curl_type" id="curl_type" value="register_member" />  
                <input type="hidden" name="m_type" id="m_type" value="register_member" />
                <input type="hidden" name="res_func" id="res_func" value="okSuccCont" />
        <div class="row">
           
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Name:</strong></label>
                <input name="first_name" id="first_name" type="text" class="form-control required" placeholder="Enter full name" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Gender:</strong></label>
                <select className='form-control required' id="gender" name="gender">
                    <option value={"0"}>-Select-</option>
                    <option value={"Male"}>Male</option>
                    <option value={"Female"}>Female</option>
                </select>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Date of Birth:</strong></label>
                <TableDatePicker class="form-control required" refName="dob"/>
                {/* <input name="date_of_birth" type="date" class="form-control required" /> */}
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Birth Time:</strong></label>
                <input name="time" id="time" type="time" class="form-control required" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Birth Place:</strong></label>
                <input name="birth_place" id="birth_place" type="text" class="form-control required" placeholder="Enter birth place" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Height (in feet):</strong></label>
                <input name="height" id="height" type="number" class="form-control required" placeholder="Enter height" required/>
            </div>

            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Skin Colour:</strong></label>
                <select className='form-control required' id="skin_color" name="skin_color">
                    <option value={"0"}>-Select-</option>
                    <option value={"Fair"}>Fair</option>
                    <option value={"Light"}>Light</option>
                    <option value={"Medium"}>Medium</option>
                    <option value={"Dark"}>Dark</option>
                </select>
                
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Highest Qualification:</strong></label>
                <select className='form-control required' id="max_qualification" name="max_qualification">
                    <option value={"0"}>-Select-</option>
                    <option value={"12th"}>12th</option>
                    <option value={"Graduation"}>Graduation</option>
                    <option value={"Post Graduation"}>Post Graduation</option>
                    <option value={"Engineering"}>Engineering</option>
                    <option value={"Medicine"}>Medicine</option>
                    <option value={"Law"}>Law</option>
                    <option value={"Management"}>Management</option>
                    <option value={"Doctor"}>Doctor</option>
                    <option value={"Other Diploma"}>Other Diploma</option>
                </select>
                
            </div>
           
        </div>
    
        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Highest Qualification Details:</strong></label>
            <input name="max_qualification_det" id="max_qualification_det" type="text" class="form-control required" placeholder="Enter Qualification Degree/College/University Name" required/>
        </div>

        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Occupation:</strong></label>
            <input name="occupation" id="occupation" type="text" class="form-control required" placeholder="Enter occupation"/>
        </div>
        <div class="row">
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>State:</strong></label>
            <select className='form-control required' id="state_nm" name="state_nm">
                    <option value={"0"}>-Select-</option>
                    {stStates.map((item,index)=>{
                        return <option value={item["name"]}>{item["name"]}</option>
                    })}
                  
                </select>
        </div>
        

        
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>City:</strong></label>
            <input type='text' name="city_nm" id="city_nm" class="form-control required" placeholder='City Name' />
        </div>
        <div class="col-md-12 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Address:</strong></label>
            <textarea name="address" id="address" class="form-control required" placeholder="Enter full address" rows="2" required></textarea>
        </div>
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Landmark:</strong></label>
            <input type='text' name="landmark" id="landmark" class="form-control required" placeholder='Landmark' />
        </div>

        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Pincode:</strong></label>
            <input type='text' name="pincode" id="pincode" class="form-control required" placeholder='Pincode' />
        </div>

        </div>

       
        

        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mobile No.:</strong></label>
                <input name="contact_no" id="contact_no" type="tel"  class="form-control required" placeholder="Enter mobile number" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Email ID:</strong></label>
                <input name="email" id="email" type="email" class="form-control required" placeholder="Enter email address"/>
            </div>
        </div>

        <h4 class="mt-4">Family Details</h4>

        <div class="row">
        
        <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Name:</strong></label>
                <input name="father_nm" id="father_nm" type="text" class="form-control required" placeholder="Enter father's name" required/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mother's Name:</strong></label>
                <input name="mother_name" id="mother_name" type="text" class="form-control required" placeholder="Enter mother's name" required/>
            </div>
           
        
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Occupation:</strong></label>
                <input name="father_occup" id="father_occup" type="text" class="form-control required" placeholder="Enter father's occupation"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Father's Mobile No.:</strong></label>
                <input name="father_contact" id="father_contact" type="tel" class="form-control required" placeholder="Enter father's mobile"/>
            </div>
            <div class="row">
                <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                    <label class="float-left"><strong>Mother's Occupation:</strong></label>
                    <input name="mother_occup" id="mother_occup" type="text" class="form-control required" placeholder="Enter mother's occupation"/>
                </div>
                <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                    <label class="float-left"><strong>Mother's Mobile No.:</strong></label>
                    <input name="mother_contact" id="mother_contact" type="tel" class="form-control required" placeholder="Enter mother's mobile"/>
                </div>
            </div>
        </div>

        <h4 class="mt-4">Income</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Family Annual Income:</strong></label>
                
                <select className='form-control required' id="family_anum" name="family_anum">
                    <option value={"0"}>-Select-</option>
                    <option value={"6"}>5 to 6 lac per year</option>
                    <option value={"8"}>6 to 8 lac per year</option>
                    <option value={"10"}>8 to 10 lac per year</option>
                    <option value={"15"}>10 to 15 lac per year</option>
                    <option value={"20"}>15 to 20 lac per year</option>
                    <option value={"30"}>20 to 30 lac per year</option>
                    <option value={"40"}>30 to 40 lac per year</option>
                    <option value={"41"}>Greater than 40 lac per year</option>
                </select>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Annual Income:</strong></label>
                <select className='form-control required' id="self_anum" name="self_anum">
                    <option value={"0"}>-Select-</option>
                    <option value={"6"}>5 to 6 lac per year</option>
                    <option value={"8"}>6 to 8 lac per year</option>
                    <option value={"10"}>8 to 10 lac per year</option>
                    <option value={"15"}>10 to 15 lac per year</option>
                    <option value={"20"}>15 to 20 lac per year</option>
                    <option value={"30"}>20 to 30 lac per year</option>
                    <option value={"40"}>30 to 40 lac per year</option>
                    <option value={"41"}>Greater than 40 lac per year</option>
                </select>
                {/* <input name="self_anum" id="self_anum" type="number" class="form-control required" placeholder="Self Annual Income"/> */}
            </div>
        </div>

        <h4 class="mt-4">Goutra</h4>
        {/* {stGotraList.map((item,index)=>{
            return <div>{item["temple_name"]}</div>
        })} */}
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Goutra:</strong></label>
                <select className='form-control required' id="self_goutra" name="self_goutra">
                    <option value={"0"}>-Select-</option>
                    {stGotraList.map((item,index)=>{
                        return <option value={item["temple_name"]}>{item["temple_name"]}</option>
                    })}
                </select>
                
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mama Goutra:</strong></label>
                <select className='form-control required' id="mama_goutra" name="mama_goutra">
                    <option value={"0"}>-Select-</option>
                    {stGotraList.map((item,index)=>{
                        return <option value={item["temple_name"]}>{item["temple_name"]}</option>
                    })}
                </select>
            </div>
        </div>
        {/* <h4 class="mt-4">Kuldevi</h4>
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Self Kuldevi:</strong></label>
                <input name="kuldevi_self" type="text" class="form-control" placeholder="Enter Kuldevi"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Mama Kuldevi:</strong></label>
                <input name="kuldevi_mama" type="tel" class="form-control" placeholder="Enter Mama Kuldevi"/>
            </div>
        </div> */}
        <h4 class="mt-4">Mangalic Status</h4>
        <div class="row">
        <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_is"><strong>Mangalic Status:</strong></label>
                <select id="mangalic_status" name="mangalic_status" class="form-control select">
                    <option value={"0"}>Select</option>
                    <option value={"Mangalic"}>Mangalic</option>
                    <option value={"Anshik Mangalic"}>Anshik Mangalic</option>
                    <option value={"General"}>General</option>
                    
                </select>
                
            </div>
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_is"><strong>Marital Status:</strong></label>
                <select id="marital_status" name="marital_status" class="form-control">
                    <option value={"0"}>Select</option>
                    {/* <option value={"Married"}>Married</option> */}
                    <option value={"Unmarried"}>Unmarried</option>
                    <option value={"Divorced"}>Divorced</option>
                    <option value={"Widow (विधवा)"}>Widow (विधवा)</option>
                    <option value={"Widower (विधुर)"}>Widower (विधुर)</option>
                    
                </select>
               
            </div>
        </div>
        <h4 class="mt-4">Siblings Details</h4>
        <div class="row">
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="brother_status"><strong>Brother *:</strong></label>
                <select id="brother_status" name="brother_status" class="form-control required">
                    <option value={"0"}>Select</option>
                    <option value={"No Brother"}>No Brother</option>
                    <option value={"Unmarried"}>Unmarried</option>
                    <option value={"Married"}>Married</option>
                </select>
                <input name="brother_det" id="brother_det" type="text" class="form-control mt-1" placeholder="Enter details if Brother is Married"/>
            </div>
    
            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="sister_status"><strong>Sister:</strong></label>
                <select id="sister_status" name="sister_status" class="form-control required">
                    <option value={"0"}>Select</option>
                    <option value={"No Sister"}>No Sister</option>
                    <option value={"Unmarried"}>Unmarried</option>
                    <option value={"Married"}>Married</option>
                </select>
                <input name="sister_det" id="sister_det" type="text" class="form-control mt-1" placeholder="Enter details if Sister is Married"/>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 1 Name:</strong></label>
                <input name="ref_one_nm" id="ref_one_nm" type="text" class="form-control" placeholder="Enter name"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 1 Contact:</strong></label>
                <input name="ref_one_contact" id="ref_one_contact" type="tel" class="form-control" placeholder="Enter contact number"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 2 Name:</strong></label>
                <input name="ref_two_nm" id="ref_two_nm" type="text" class="form-control" placeholder="Enter name"/>
            </div>
            <div class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Reference Person 2 Contact:</strong></label>
                <input name="ref_two_contact" id="ref_two_contact" type="tel" class="form-control" placeholder="Enter contact number"/>
            </div>
            <div  style={{"position":"relative"}} class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Password:</strong></label>
               
    <input type="password" id="password" name="password" class="form-control required" placeholder="Enter Password" />
    <i class="fa fa-eye" id="togglePassword"
       style={{"position":"absolute","right":"21px","top":"38px","cursor":"pointer"}}></i>
            </div>

            <div style={{"position":"relative"}} class="col-md-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Re-Enter Password:</strong></label>
                   
    <input type="password" name="re_password" id="re_password" class="form-control required" placeholder="Enter Password" />
    <i class="fa fa-eye" id="toggleRePassword"
       style={{"position":"absolute","right":"21px","top":"38px","cursor":"pointer"}}></i>
                
            </div>

            <div class="form-group col-md-6 pl-2 pr-2 mb-4">
                <label class="float-left" name="registered_by"><strong>Registered By:</strong></label>
                <select id="registered_by" name="registered_by" class="form-control required">
                    <option>Select</option>
                    <option value={"Self"}>Self</option>
                    <option value={"Parents"}>Parents</option>
                    
                    
                </select>
                
            </div>
        </div>

        <div class="text-center mt-4">
            <button type="button" onClick={()=>addMemeberReq()} class="btn btn-primary me-2">Submit</button>
            <button type="reset" class="btn btn-secondary">Reset</button>
        </div>
    </form>
</div>

                </div>
            </div>
        </div>
        </div>
     
        {/* <Footer/> */}
        <Comp_Sf_Footer/>
</>)
}
export default Member_Reg;